module.exports = __webpack_public_path__ + "img/Trinidad and Tobago.c224149c.svg";